import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-30" }
const _hoisted_2 = { class: "min-h-24" }
const _hoisted_3 = { class: "font-bold mr-8" }
const _hoisted_4 = { class: "font-bold mr-8" }
const _hoisted_5 = {
  key: 0,
  class: "my-x4 font-bold"
}
const _hoisted_6 = {
  key: 1,
  class: "flex mt-x4"
}
const _hoisted_7 = {
  key: 0,
  class: "mb-x2"
}
const _hoisted_8 = { class: "block font-bold" }
const _hoisted_9 = { class: "block" }
const _hoisted_10 = { class: "block" }
const _hoisted_11 = { class: "block" }
const _hoisted_12 = {
  key: 0,
  class: "mt-x2"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "w-100"
}
const _hoisted_15 = { class: "ml-auto max-w-half" }
const _hoisted_16 = { class: "block font-bold" }
const _hoisted_17 = {
  key: 0,
  class: "c-select c-select--highlighted border-silver w-full min-w-250 mt-7 pr-20"
}
const _hoisted_18 = {
  key: "choose",
  value: ""
}
const _hoisted_19 = ["value"]

import useBooleanToggle from '@/shared/useBooleanToggle';
import {
    CustomerDeliveryCheckOutDeliverable,
    DeliveryTimeSlotModel,
    DeliveryType,
    HubModel,
    LabelWithNamedArguments,
    PickUpCheckOutDeliverable,
} from '@/storecontext/shared/api/server-apis';
import { computed, ref, watch } from 'vue';
import CheckoutChangePickUp from './CheckoutChangePickUp.vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import { useStepReset } from '@/storecontext/checkout/useStepReset';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import CheckoutSkeletonLine from '@/storecontext/shared/checkout/ui/CheckoutSkeletonLine.vue';
import useCountries from '@/shared/address/useCountries';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickUpOption',
  props: {
    deliverable: null
  },
  emits: ['client-validity-change', 'hubs-loaded'],
  setup(__props: any, { emit }) {

const props = __props as {
    deliverable: CustomerDeliveryCheckOutDeliverable | PickUpCheckOutDeliverable;
}




const { getPickUpPointsForDelivery, getPickUpTimesForCustomerDelivery, setDeliveryTime, getPickUpErrorMessageId } = useCheckout();
const { isToggled, toggle } = useBooleanToggle();
const resetStep = useStepReset();
const labels = useBlockLabels();
const { siteCountryName } = useCountries();

const hubs = ref<HubModel[]>([]);
const selectedHubId = ref<string>();
const selectedHubModel = computed(() => hubs.value?.find(hub => hub.id === selectedHubId.value));
const deliveryTimeSlotModel = ref<DeliveryTimeSlotModel>({} as DeliveryTimeSlotModel);
const deliveryTimeSlotMessage = ref<LabelWithNamedArguments|undefined>();
const selectedDeliveryTimeSlotId = ref<number|undefined>();
const showNotifyNoAvailableHubs = ref<boolean>(false);

const maybeSetSelectedDeliveryTimeSlotId = () => {
    if (props.deliverable.deliveryType === DeliveryType.PickUp) {
        selectedDeliveryTimeSlotId.value = props.deliverable?.deliveryTimeId;
    }
};

maybeSetSelectedDeliveryTimeSlotId();

const setHubs = async() => {
    const response = await getPickUpPointsForDelivery(props.deliverable.id);
    hubs.value = response.hubs;
    selectedHubId.value = response.defaultPickUpId;
    showNotifyNoAvailableHubs.value = response.hubs?.length === 0;
    try {
        await getPickUpTimeSlots();
    } finally {
        emit('hubs-loaded');
    }
};

setHubs();

const setHub = async(hub: HubModel) => {
    selectedHubId.value = hub.id;
    resetStep();
    await getPickUpTimeSlots();
};

const changePickUpPoint = () => {
    toggle();
};

const getPickUpTimeSlots = async(): Promise<void> => {
    if (selectedHubId.value) {
        const response = await getPickUpTimesForCustomerDelivery(props.deliverable.id, selectedHubId.value);
        deliveryTimeSlotMessage.value = response.message;
        if (response.deliveryTimeSlotModel) {
            deliveryTimeSlotModel.value = response.deliveryTimeSlotModel;
            updateSelectedTimeSlotIfAvailableOrManualType();
        };
    };
};

const updateSelectedTimeSlotIfAvailableOrManualType = (): void => {
    const firstAvailableSlot = deliveryTimeSlotModel.value.deliverySlots?.length ? deliveryTimeSlotModel.value.deliverySlots[0].deliveryTimeId : undefined;
    const containsTimeSlot = deliveryTimeSlotModel.value.deliverySlots?.find(slot => slot.deliveryTimeId === selectedDeliveryTimeSlotId.value) ?? false;
    const isManualTypeTimeSlot = deliveryTimeSlotModel.value.deliveryType === DeliveryType.Manual;
    if (!containsTimeSlot) {
        selectedDeliveryTimeSlotId.value = firstAvailableSlot;
    };
    if (containsTimeSlot || isManualTypeTimeSlot || firstAvailableSlot) {
        updateSelectedTimeSlot();
    }
};

const updateSelectedTimeSlot = async(): Promise<void> => {
    const request = {
        deliveryType: deliveryTimeSlotModel.value.deliveryType,
        requestedDeliveryType: deliveryTimeSlotModel.value.requestedDeliveryType,
        postalCode: deliveryTimeSlotModel.value.postalCode,
        inventoryLocationId: deliveryTimeSlotModel.value.inventoryLocationId,
        deliveryTime: deliveryTimeSlotModel.value.deliverySlots?.find(slot => slot.deliveryTimeId === selectedDeliveryTimeSlotId.value),
    };
    await setDeliveryTime(props.deliverable.id, request, getPickUpErrorMessageId(props.deliverable.id));
};

const shouldShowFreightPrice = computed<boolean>(() => {
    return props.deliverable.deliveryType === DeliveryType.PickUp && !!props.deliverable?.freight;
});

const hubLocationOrTimeSlotChangeKey = computed<string>(() => (deliveryTimeSlotModel.value?.postalCode ?? 0) + (selectedDeliveryTimeSlotId?.value ?? 0));

watch(hubLocationOrTimeSlotChangeKey, () => {
    const isManualDeliveryType = deliveryTimeSlotModel.value.deliveryType === DeliveryType.Manual;
    const hasSelectedTimeSlot = selectedDeliveryTimeSlotId.value !== undefined;
    emit('client-validity-change', hasSelectedTimeSlot || isManualDeliveryType);
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  const _component_InputSelect = _resolveComponent("InputSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "o-anim-fade-300",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_unref(shouldShowFreightPrice))
            ? (_openBlock(), _createElementBlock("div", {
                key: __props.deliverable?.freight?.price?.amount ?? 0
              }, [
                (__props.deliverable.freight?.errorGettingPrice)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(labels).pickUpPrice), 1),
                      _createTextVNode(_toDisplayString(_unref(labels).pickUpPriceAmountUnavailable), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(labels).pickUpPrice), 1),
                      _createTextVNode(_toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).pickUpPriceAmount, { amount: __props.deliverable?.freight?.price?.amount })), 1)
                    ], 64))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (showNotifyNoAvailableHubs.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).pickUpNoAvailablePickUpPoints, { country: _unref(siteCountryName) })), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(selectedHubModel))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(selectedHubModel).name), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(selectedHubModel).street), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(selectedHubModel).zipCode) + " " + _toDisplayString(_unref(selectedHubModel).city), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(selectedHubModel).countryName), 1),
                    (hubs.value.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("button", {
                            class: "c-button c-button--outline",
                            onClick: _withModifiers(changePickUpPoint, ["prevent"])
                          }, _toDisplayString(_unref(labels).pickUpChangePickUpPointButton), 9, _hoisted_13)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(CheckoutSkeletonLine, { class: "mb-8" }),
                    _createVNode(CheckoutSkeletonLine, { class: "mb-8" }),
                    _createVNode(CheckoutSkeletonLine)
                  ])),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(labels).pickUpTimeslotTitle), 1),
                (!deliveryTimeSlotModel.value.deliverySlots)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(deliveryTimeSlotMessage.value ? _unref(labels).pickUpTimeslotUnavailable : _unref(labels).pickUpTimeslotLoading), 1))
                  : (_openBlock(), _createBlock(_component_InputSelect, {
                      key: 1,
                      modelValue: selectedDeliveryTimeSlotId.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDeliveryTimeSlotId).value = $event)),
                      class: "min-w-250",
                      highlighted: true,
                      name: `delivery-time-pick-up-${__props.deliverable.id}`,
                      onChange: updateSelectedTimeSlot
                    }, {
                      default: _withCtx(() => [
                        (!selectedDeliveryTimeSlotId.value)
                          ? (_openBlock(), _createElementBlock("option", _hoisted_18, _toDisplayString(_unref(labels).pickUpSelectTimeslot), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryTimeSlotModel.value.deliverySlots, (slot) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: slot.deliveryTimeId,
                            value: slot.deliveryTimeId
                          }, _toDisplayString(slot.formattedDeliveryDate), 9, _hoisted_19))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "name"])),
                (deliveryTimeSlotMessage.value)
                  ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
                      key: 2,
                      label: deliveryTimeSlotMessage.value,
                      class: "mt-x2"
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      _: 1
    }),
    (selectedHubId.value)
      ? (_openBlock(), _createBlock(CheckoutChangePickUp, {
          key: 0,
          hubs: hubs.value,
          "selected-id": selectedHubId.value,
          "select-label": _unref(labels).pickUpPointDialogSelectHub,
          "selected-label": _unref(labels).pickUpPointDialogSelectedHub,
          deliverable: __props.deliverable,
          "is-open": _unref(isToggled),
          onSelect: setHub,
          onClose: _unref(toggle)
        }, null, 8, ["hubs", "selected-id", "select-label", "selected-label", "deliverable", "is-open", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}
}

})